import { LoadingState } from '@lib-ui/lib/models/loading-state';
import { Signal } from '@angular/core';

export interface ServiceState {
  status: Signal<LoadingState>;
  error: Signal<Error | null>;
}
